export const TOGGLE_ADD_ADDRESS_POPUP = 'TOGGLE_ADD_ADDRESS_POPUP'

export function displayAddAddressPopupReducer (state = {value: false}, action) {
    switch (action.type){
        case TOGGLE_ADD_ADDRESS_POPUP:
            return action.payload
        default: return state
    }
}